import { createSlice } from "@reduxjs/toolkit";
import { DROPDOWN_LISTING_DATA } from "../constants";

export const dropDownListSlice = createSlice({
  name: DROPDOWN_LISTING_DATA,
  initialState: {
    clientList: [],
    resellerList: [],
    serviceProviderList: [],
    serviceType: [],
    salesList: [],
    serviceProviderNameList: [],
    resellerServiceProviderList: [],
  },
  reducers: {
    addResellerDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        resellerList: data,
      });
    },
    addClientDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        clientList: data,
      });
    },
    addServiceProviderDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        serviceProviderList: data,
        serviceProviderNameList: data,
      });
    },
    addResellerServiceProviderDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        resellerServiceProviderList: data,
      });
    },
    addServiceProviderNameDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        serviceProviderNameList: data,
      });
    },
    addSalesDropdownList: (state, action) => {
      const data = [...action.payload];
      return (state = {
        ...state,
        salesList: data,
      });
    },
  },
});

export const {
  addResellerDropdownList,
  addClientDropdownList,
  addServiceProviderDropdownList,
  addSalesDropdownList,
  addServiceProviderNameDropdownList,
  addResellerServiceProviderDropdownList,
} = dropDownListSlice.actions;

export default dropDownListSlice.reducer;
